import { SubsidiaryModeAlert } from "PFApp/components/subsidiary_mode_alert";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";

import { useActivityShowContext } from "../../context/activity_show_context";
import { useActivityCompareStore, useActivityCompareStoreActions } from "../../store/activity_compare";
import css from "../activity_page.module.scss";

export const ComparisonToast = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation("activities");

  const { activityId } = useActivityShowContext();
  const compareIds = useActivityCompareStore((state) => state.compareIds);
  const { clearComparisonToast } = useActivityCompareStoreActions();

  const keys = Object.keys(compareIds);
  const comparisonListLength = keys.length;

  const comparisonLocation = {
    pathname: `/activities/${activityId}/compare/details/${keys.join(",")}`,
    state: { prevPath: `${location.pathname}${location.search}` }
  };

  if (!comparisonListLength) {
    return null;
  }

  return (
    <div className={css.compareAlert}>
      <SubsidiaryModeAlert
        onClose={clearComparisonToast}
        title={
          comparisonListLength > 1
            ? t("show.countSelected", { count: comparisonListLength })
            : t("show.selectOneProfile")
        }
        actions={[
          {
            icon: "compare",
            onClick: () => navigate(comparisonLocation),
            disabled: comparisonListLength < 2
          }
        ]}
      />
    </div>
  );
};
